export const links = (state) => state.links;